import MessageType from '../../enums/MessageType';
import Translation from '../lang/Translation';
import doMetric from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';
import * as types from './action-types';

export const setPageMessage = (message, messageType = MessageType.ERROR) => {
  try {
    doMetric('pageMessageError', [{
      name: 'pageErrorReturned',
      value: message || Translation.getText('errors.mainFormError'),
    }, {
      name: 'pageErrorTypeReturned',
      value: messageType,
    }], [], 'impression');
  } catch (error) {
    Track.track(error);
  }
  return {
    type: types.SET_PAGE_MESSAGE,
    message: message || Translation.getText('errors.mainFormError'),
    messageType,
  };
};

export const removePageMessage = () => ({
  type: types.REMOVE_PAGE_MESSAGE,
});
